export const guardUserAction = (e: any, activated: boolean): void => {
  if (!activated) {
    e.preventDefault();
    document.getElementById("promptCompleteProfileModal")?.click();
    return;
  }
};
